export default __webpack_public_path__ + "images/0x10010078a54396f62c96df8532dc2b4847d47ed3.png";